module.exports = __webpack_public_path__ + "static/media/table.044e5eff.jpg";